import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    show: _ctx.show,
    "is-simple": "",
    "simple-ok-label": "Close anyway",
    "simple-cancel-label": "Continue with test",
    onOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.isMaths)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" You haven't completed this activity. Are you sure you want to close it? ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" If you close now you will lose all your progress and your points will not be saved. ")
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}